import { useEffect, useState } from 'react';
import { jwtDecode } from 'jwt-decode';
import apiClient from '../../../../../utils/apiClient';
import handleEmptyTableResponse from '../../../common/table/utils/handle-empty-table-response';
// TODO(PMAGM-pma-filter): import { isPmaManagerRole } from '../../../../../utils/role-utils'; once the "PMA" filter is wired to the backend.
import {
  getNextSortDirection,
  getStoredFilters,
  saveFilters,
  sortRows,
} from '../../../../../utils/tableUtils';
import {
  DEFAULT_FILTERS,
  EMPTY_FILTERS,
  FILTERS_STORAGE_KEY,
} from '../domain/table-hac.constants';
import {
  SORT_COMPARATORS,
  filterHacs,
  getRetailerOptions,
  sortHacsForPma,
} from '../domain/table-hac.utils';

function usePmaHacTable({ reload, onDataLoaded, t }) {
  const token = sessionStorage.getItem('token') || null;
  const decodedToken = jwtDecode(token);
  const pmaId = decodedToken.id;
  // TODO(PMAGM-pma-filter): const isPmaManager = isPmaManagerRole(decodedToken.role);

  const [dataLoaded, setDataLoaded] = useState(false);
  // TODO(PMAGM-pma-filter): fetch the PMAGM's team for the "PMA" filter once the backend exposes it.
  // const [pmas, setPmas] = useState([]);
  const [hacs, setHacs] = useState([]);
  const [filteredHacs, setFilteredHacs] = useState([]);
  const [countries, setCountries] = useState([]);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [order, setOrder] = useState('');
  const [orderBy, setOrderBy] = useState('');
  const [filters, setFilters] = useState(() => getStoredFilters(FILTERS_STORAGE_KEY, DEFAULT_FILTERS));

  const fetchData = async () => {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        'Cache-Control': 'no-cache',
      },
    };

    try {
      const response = await apiClient.get(`/pma/hacs?pmaId=${pmaId}`, config);

      if (response.status === 200) {
        const sortedHacs = sortHacsForPma(response.data);

        setHacs(sortedHacs);
        setFilteredHacs(filterHacs(sortedHacs, filters));
        setDataLoaded(true);
        if (typeof onDataLoaded === 'function') onDataLoaded();
      }

      if (response.status === 204) {
        handleEmptyTableResponse({
          clearStateSetters: [setHacs, setFilteredHacs],
          onDataLoaded,
          setDataLoaded,
        });
      }
    } catch (error) {
      if (error.response) {
        setSnackbarOpen(true);
        setSnackbarMessage(t('common-internal-server-error'));
      }
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (!reload) return;
    fetchData();
    // eslint-disable-next-line
  }, [reload]);

  // TODO(PMAGM-pma-filter): load the PMAGM's team once the backend exposes it, to populate the "PMA" filter options.
  // useEffect(() => {
  //   if (!isPmaManager) return;
  //   const config = { headers: { Authorization: `Bearer ${token}`, 'Cache-Control': 'no-cache' } };
  //   apiClient.get(`/pma/team?pmaId=${pmaId}`, config).then((response) => {
  //     if (response.status === 200) setPmas(response.data);
  //   });
  //   // eslint-disable-next-line
  // }, [isPmaManager]);

  useEffect(() => {
    setCountries([...new Set(hacs.map((hac) => hac.area_code))]);
  }, [hacs]);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    const updatedFilters = {
      ...filters,
      [name]: value,
    };

    if (name === 'retailer' && value) {
      const matched = hacs.find((hac) => hac.retailer_name === value);
      if (matched) {
        updatedFilters.country = matched.area_code;
      }
    }

    setFilters(updatedFilters);
  };

  const applyFilters = (appliedFilters = filters, hacsData = hacs) => {
    setFilteredHacs(filterHacs(hacsData, appliedFilters));
    saveFilters(FILTERS_STORAGE_KEY, appliedFilters);
  };

  const resetFilters = () => {
    setFilters(EMPTY_FILTERS);
    applyFilters(EMPTY_FILTERS, hacs);
  };

  const handleRequestSort = (property) => {
    setOrder(getNextSortDirection(orderBy, order, property));
    setOrderBy(property);
  };

  return {
    countries,
    dataLoaded,
    filters,
    filteredHacs,
    hacs,
    order,
    orderBy,
    // isPmaManager, // TODO(PMAGM-pma-filter): expose once the "PMA" filter is enabled
    // pmas, // TODO(PMAGM-pma-filter): expose once the "PMA" filter is enabled
    retailers: getRetailerOptions(hacs, filters),
    rows: sortRows(filteredHacs, orderBy, order, SORT_COMPARATORS),
    snackbarMessage,
    snackbarOpen,
    handleApplyFilter: () => applyFilters(),
    handleFilterChange,
    handleRequestSort,
    handleSnackbarClose: () => setSnackbarOpen(false),
    resetFilters,
  };
}

export default usePmaHacTable;
